import script from "./ExchangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeModal.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeModal.vue?vue&type=style&index=0&id=fe559be0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe559be0"]])

export default __exports__